import { getJwtPayload } from "./jwt";
import sessionDB from "../utils/sessionDB";

export function getUserRoleFromToken(token = sessionDB.getAccessToken()) {
  const payload = getJwtPayload(token);
  if (!payload) return null;

  const role =
    payload.role ??
    payload.canonical_role_name ??
    payload.roles ??
    payload.authorities;

  if (!role) return null;
  if (typeof role === "string") return role;
  if (Array.isArray(role)) return role.join(",");
  return null;
}

/**
 * Canonical roles now come from the session (empobj.canonical_role_name,
 * persisted by sessionDB at login) with a JWT-claim fallback — instead of a
 * separate hand-maintained `empObj` key in localStorage that could drift out
 * of sync with the actual signed-in session.
 */
export function getCanonicalRoles() {
  const fromSession = sessionDB.getCanonicalRoleName();
  if (fromSession) return fromSession.split(",").map((r) => r.trim().toLowerCase());

  const fromJWT = getUserRoleFromToken();
  if (fromJWT) return fromJWT.split(",").map((r) => r.trim().toLowerCase());
  return [];
}

export function hasCanonicalRole(role) {
  if (!role) return false;
  const normalized = String(role).trim().toLowerCase();
  return getCanonicalRoles().includes(normalized);
}

export function hasAnyCanonicalRole(roles = []) {
  const canonicalRoles = getCanonicalRoles();
  return roles.some((role) => canonicalRoles.includes(String(role).trim().toLowerCase()));
}
